export default __webpack_public_path__ + "75423608d039287a820d7e15e65616a6.png";